export default __webpack_public_path__ + "static/media/bliss.54d49775.png";